<template>
  <b-spinner v-if="loading && showLoading" variant="primary" />

  <span class="error-text" v-else-if="!loading && loadingError && !isImage && notImageText">{{ notImageText }}</span>

  <span class="error-text" v-else-if="!loading && loadingError && errorText">{{ errorText }}</span>

  <img v-else-if="!loading && !loadingError && src" :src="src" :alt="alt" />
</template>

<script>
import { mapActions } from 'vuex';

import isImage from '@/utils/isImage';

export default {
  name: 'S3FileImage',

  props: {
    s3Key: {
      type: String,
      default: undefined,
    },
    alt: {
      type: String,
      default: undefined,
    },
    errorText: {
      type: String,
      default: undefined,
    },
    notImageText: {
      type: String,
      default: undefined,
    },
    showLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      loadingError: false,
      src: null,
    };
  },

  methods: {
    ...mapActions(['fetchS3DownloadLink']),

    isImage,

    async getFileLink(s3Key) {
      if (!isImage(s3Key)) {
        this.src = null;
        this.loadingError = true;
        return;
      }

      this.loading = true;
      this.loadingError = false;

      try {
        this.src = await this.fetchS3DownloadLink({ s3Key: this.s3Key });
      } catch (error) {
        this.loadingError = true;
        this.src = null;
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    s3Key: {
      immediate: true,
      handler(nextValue, prevValue) {
        if (nextValue !== prevValue) {
          this.getFileLink(nextValue);
        }
      },
    },
  },
};
</script>

<style scoped>
.error-text {
  color: var(--bs-danger);
}
</style>



// WEBPACK FOOTER //
// src/components/common/S3FileImage.vue